<template>
  <div class="loading-page">
    <div class="loading-content">
      <img src="@/assets/img/logo.svg" alt="Logo Venda e Ganhe" />
      <div class="progress-container">
        <b-progress type="is-primary" size="is-small"></b-progress>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loading-page',
};
</script>

<style lang="scss" scoped>
.loading-page {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;

  .loading-content {
    img {
      width: 300px;
      margin-bottom: 16px;
      animation: zooming 1.5s infinite;
    }
  }
}

@keyframes zooming {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>
